import { CofidocBilling } from "@/api/billing/fetchCofidocBill";
import { fetchCofidocBillings } from "@/api/billing/fetchCofidocBillings";
import { useSystemContext } from "@/provider/common/SystemProvider";
import React, { useState, useEffect } from "react";

export function BillingViewWrapper({ children }) {
  const [billing, setBilling] = useState<CofidocBilling[]>();
  const { setLoading, getUser } = useSystemContext();

  async function getData() {
    try {
      setLoading(true);
      const user = getUser();
      const email = user?.email || null;
      const username = user?.identifiant || null;

      const b = await fetchCofidocBillings({ username, email });

      setBilling(b);
    } catch (error) {
      console.log("error :", error);
    } finally {
      setLoading(false);
    }
  }

  // fetchCofidocBillings ramène toutes les factures en une fois (pas de filtre par date côté API) :
  // le filtrage par année se fait ensuite côté client dans BillingViewCpnWeb/BillViewMobile,
  // donc un seul fetch au montage suffit — inutile de refetch à chaque changement d'année.
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{React.cloneElement(children, { billing })}</>;
}
